import React from 'react';
import Logotipo from '../../images/logotipo.png';
import Check from '../../images/Footer/ico-check.png';
import './styles.scss';

function Footer () {
  return (
    <div className="footer__container">
      <div class="top__container">
        <a href="https://www.megacable.com.mx/">
          <img class="footer__logotipo" src={Logotipo} alt="Logotipo" />
        </a>
        <div className="info__container">
          <a href="https://www.megacable.com.mx/">Términos y Condiciones</a>
          <a href="https://www.megacable.com.mx/">Aviso de Privacidad</a>
          <a href="https://www.megacable.com.mx/">Política y Seguridad</a>
        </div>
      </div>
      <div className="bottom__container">
        <div className="telephone__number__container">
          <p className="number__text">Para contratar déjanos tu número <span>y te marcaremos en segundos.</span></p>
          <div className="telephone__container">
            <p>55 1234 5678</p>
          </div>
        </div>
        <div className="terms__button__container">
          <div className="terms__container">
            <img className="check__icon" src={Check} alt="Check"></img>
            <p>He leído y acepto los <a href="https://www.megacable.com.mx/">Términos y Condiciones</a></p>
          </div>
          <button className="apply__button">solicitar</button>
        </div>
      </div>
    </div>
  );
}

export default Footer;
